export const CHOICE_SEARCH = '/domain/choice/search'
